import { defineNuxtPlugin } from "#app";
import { createAuthContext, provideAuthToApp } from "@kopf3/adapt-oidc-component";

export default defineNuxtPlugin(async nuxtApp => {
    const cfg = useRuntimeConfig();
    const oidcConfig = {
        client_id: cfg.public.OIDC_CLIENT_ID,
        redirect_uri: cfg.public.OIDC_REDIRECT_URI,
        authority: cfg.public.OIDC_AUTHORITY,
        scope: "openid profile email",
        response_type: "code",
        silent_redirect_uri: cfg.public.OIDC_SILENT_REDIRECT_URI,
        automaticSilentRenew: true,
    };
    const auth = createAuthContext(oidcConfig);

    provideAuthToApp(nuxtApp.vueApp, auth);

    await auth.fetchUser();

    const path = window.location.pathname;
    const isLoginPath = path === "/login" || path === "/callback";
    if (!auth.isAuthenticated.value && !isLoginPath) {
        await auth.login();
    }
});
